import { render, staticRenderFns } from "./POSMain.vue?vue&type=template&id=70e80f95"
import script from "./POSMain.vue?vue&type=script&lang=js"
export * from "./POSMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports